import * as defaultImport from "@splunk/react-ui/Link";
export * from "@splunk/react-ui/Link";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
